/**
 * Copyright 2023 Design Barn Inc.
 */

import type { ThemeOptions } from './common';
import { LottieThemeCommon } from './common';

export class LottieTheme extends LottieThemeCommon {
  public constructor(options: ThemeOptions) {
    super(options);
  }
}
